/* eslint no-unused-vars: 0 */

import React      from 'react';
import Rebase     from 're-base';
import { base }   from '../config';
import PropTypes  from 'prop-types';
import List       from './VisitsList';
import styles     from '../styles/panels.styl';

class VisitsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      list: [],
      isAdding: false
    };
  }
  componentDidMount() {
    base.syncState('visits_2017_08_02', {
      context: this,
      state: 'list',
      asArray: true,
      queries: {
        orderByChild: 'date'
      }
    });
  }
  addVisit(visit) {
    base.push('visits', {
      data: visit,
    }).catch(err => {
      console.log(err);
      this.setState({
        isAdding: false
      });
    });
  }
  toggleForm() {
    this.setState({
      isAdding: true
    });
  }
  handleRemoveItem(index) {
    const newList = this.state.list;
    newList.splice(index, 1);
    this.setState({
      list: newList
    });
  }
  render() {
    const visits = this.props.visits;
    if (this.state.isAdding) {
      return (
        <div>
          <div className="panel panel-form">
            <div className="panel-header">
              <h1>FORM</h1>
              <button onClick={this.toggleForm.bind(this)}>Add</button>
            </div>
          </div>
          <div>
            {this.props.children}
          </div>
        </div>
      );
    }
    return (
      <div>
        <div className="panel panel-list">
          <div className="panel-header">
            <h1>Y'all Feastin'</h1>
            <button onClick={this.toggleForm.bind(this)}>Add</button>
          </div>
          <List items={(this.state.list).reverse()} remove={this.handleRemoveItem.bind(this)} />
        </div>
        <div>
          {this.props.children}
        </div>
      </div>
    );
  }
}

VisitsPage.propTypes = {
  visits: PropTypes.array,
  children: PropTypes.object,
  actions: PropTypes.object
};

VisitsPage.contextTypes = {
  user: PropTypes.object
};

export default VisitsPage;



// WEBPACK FOOTER //
// ./client/components/VisitsPage.js